document.addEventListener('DOMContentLoaded', function() {
  // Get the navigation element
  const collectionNav = document.querySelector('nav.collection__nav');
  // Get the sidebar element
  const collectionSidebar = document.querySelector('.collection__sidebar');
  
  // If the nav doesn't exist on the page, exit early
  if (!collectionNav) return;
  
  // Get the original position of the nav from the top of the page
  const navPosition = collectionNav.offsetTop;
  
  // Function to handle scroll event
  function handleScroll() {
    // If we've scrolled past the original position of the nav
    if (window.scrollY > navPosition) {
      // Add the sticky class to nav
      collectionNav.classList.add('sticky');
      
      // Add sticky_adjust class to sidebar if it exists
      if (collectionSidebar) {
        collectionSidebar.classList.add('sticky_adjust');
      }
    } else {
      // Remove the sticky class from nav
      collectionNav.classList.remove('sticky');
      
      // Remove sticky_adjust class from sidebar if it exists
      if (collectionSidebar) {
        collectionSidebar.classList.remove('sticky_adjust');
      }
    }
  }
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);
  
  // Call once on load to set initial state
  handleScroll();
});